
import { iUploadeImagesList } from '@/interface/imageUpload';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Upload from '@/components/ImagesUpload/upload.vue';
import { getGameManage } from '@/api/game-manage';
import TimeRules from './time-rules.vue';
import { toast } from '@/utils/common';
import LogUtils from 'panda-log';
import { postCloudPromotion } from '@/api//cloud-promotion';
import { iCloudUpdatePromotion } from '@/interface/cloud-update-promotion';
import { iSelectGame } from '@/interface/game-manage';
@Component({
  components: { Upload, TimeRules },
})
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() info!: iCloudUpdatePromotion;
  isDetail: boolean = false;
  title: string = '新建推广';
  enterImgUpload: iUploadeImagesList[] = [];
  gameList: any = [];
  filterable: string = '';
  num: number = 1;
  cloudForm: iCloudUpdatePromotion = {
    promotion_name: '',
    game_img: '',
    is_tryout: false,
    free_time: 30,
    config: 0,
    game_id: -1,
    id: 0,
    custom: [],
    free_duration: 0,
  };
  custom: any = [
    {
      promotion_days: [],
      promotion_periods: [{ start: 0, end: 0, startStr: '', endStr: '' }],
      free_duration: 30,
      free_time: 30,
    },
  ];
  configList: any = [
    { id: 0, value: '全时段配置' },
    { id: 1, value: '分时端配置' },
  ];
  loading = false;
  //validator
  rules: any = {
    promotion_name: [{ required: true, message: '请输入推广名称!', trigger: 'blur' }],
    game_img: [{ required: true, message: '请选择游戏图！', trigger: 'blur', validator: this.checkGameImage }],
    game_id: [{ required: true, message: '请选择游戏', trigger: 'blur', validator: this.checkGameID }],
    custom: [{ required: true, trigger: 'blur', validator: this.checkCustom }],
    free_time: [{ required: true, trigger: 'blur', validator: this.checkFreeTime }],
  };
  checkGameID(rule: any, value: any, callback: any) {
    if (this.cloudForm.is_tryout || this.cloudForm.config == 1) {
      if (this.cloudForm.game_id <= 0) {
        return callback(new Error('请选择游戏!'));
      }
      return callback();
    }
    return callback();
  }
  checkGameImage(rule: any, value: any, callback: any) {
    if (this.enterImgUpload.length === 0 && this.cloudForm.game_img == '') {
      return callback(new Error('请选择游戏图片!'));
    }
    if (this.enterImgUpload.length > 0) {
      this.cloudForm.game_img = this.enterImgUpload[0].url;
    }

    return callback();
  }
  checkFreeTime(rule: any, value: any, callback: any) {
    if (this.cloudForm.is_tryout) {
      if (!this.cloudForm.free_time) {
        return callback(new Error('请填写赠送时长！'));
      } else {
        this.cloudForm.free_duration = this.cloudForm.free_time;
      }
    } else {
      this.cloudForm.free_duration = 0;
    }
    return callback();
  }

  checkCustom(rule: any, value: any, callback: any) {
    if (this.cloudForm.config === 1) {
      if (this.custom.length === 0) {
        return callback(new Error('请添加时段!'));
      } else {
        this.custom.forEach((item: any, index: number) => {
          let locationIndex = index + 1;
          if (item.promotion_periods.length > 0) {
            item.promotion_periods.forEach((v: any) => {
              if (!v.startStr || !v.endStr) {
                return callback(new Error(`时段${locationIndex}时间段没有选中！`));
              }
            });
          }

          if (item.promotion_days.length === 0) {
            return callback(new Error(`时段${locationIndex}没有选择周期！`));
          }
          if (item.promotion_periods.length === 0) {
            return callback(new Error(`时段${locationIndex}时长！`));
          }
          if (!item.free_time) {
            return callback(new Error(`请填写时段${locationIndex}的赠送时长！`));
          } else {
            item.free_duration = item.free_time;
            return callback();
          }
        });
      }
    }

    return callback();
  }
  clearValidate() {
    console.log(this.cloudForm.config);
    if (this.cloudForm.config == 0) {
      (this.$refs as any).customTimeRules.clearValidate();
    }
  }
  @Emit()
  close() {}

  /**
   * 添加特殊时段
   */
  addRulesTime() {
    this.custom.push({
      promotion_days: [],
      promotion_periods: [{ start: 0, end: 0, startStr: '', endStr: '' }],
      free_duration: 30,
      free_time: 30,
    });
  }
  delRulesTime(index: number) {
    this.custom.splice(index, 1);
  }
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.postAddCloudUpdatePromotion();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  async postAddCloudUpdatePromotion() {
    try {
      this.cloudForm.custom = this.cloudForm.config == 1 ? this.custom : [];
      if (!this.cloudForm.is_tryout) {
        this.cloudForm.free_duration = 0;
      }
      const res: any = await postCloudPromotion(this.cloudForm);
      if (res.code == 0) {
        toast(`操作成功！`, 'success');
        this.$emit('success');
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  async getGame() {
    const item: iSelectGame = {
      source: 'select',
      page_size: 1000,
      act_free: -1,
    };
    const res: any = await getGameManage(item);
    if (res.code == 0) {
      this.gameList = res.data.list;
      this.gameList.unshift({
        name: '请选择游戏',
        id: -1,
      });
    }
  }
  handleExit() {
    this.isDetail = false;
    // console.log(this.cloudForm);
  }
  mounted() {
    this.getGame();
    let newInfo = JSON.parse(JSON.stringify(this.info));
    // this.$set(this.cloudForm, 'cloudForm', newInfo);
    this.cloudForm = newInfo;
    if (this.cloudForm.id > 0) {
      this.isDetail = true;
      if (this.cloudForm.custom.length > 0) {
        this.custom = this.cloudForm.custom;
        // this.cloudForm.config = 1;
        this.$set(this.cloudForm, 'config', 1);
      } else {
        // this.cloudForm.config = 0;
        this.$set(this.cloudForm, 'config', 0);
      }
      if (this.cloudForm.is_tryout) {
        this.cloudForm.free_time = this.cloudForm.free_duration;
      }
    }
  }
}
